// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

class NotAllowed extends React.Component {
	render() {
		return (
			<div className="page-section">
				<div className="content-body-wrap">
					<div className="content-body">
						<div className="page-title">
							<h1>Not Available</h1>

							<div className="page-intro">
								You are not allowed to view this page.
							</div>
						</div>

						<div className="content-body-text"></div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( NotAllowed )



// WEBPACK FOOTER //
// ./views/main/page/NotAllowed.jsx